import ApiService from './ApiService';

export default class GeneralSettingApi extends ApiService {
    constructor() {
        super('general-setting');
    }

    updateGereralSettingByType(payload) {
        const { type, value } = payload;
        return this.put(type, { value });
    }

    getGereralSettingByType(type) {
        return this.get(type);
    }
}
